import { render, staticRenderFns } from "./EstadisticaTrabajador.vue?vue&type=template&id=be519d08&scoped=true&"
import script from "./EstadisticaTrabajador.vue?vue&type=script&lang=js&"
export * from "./EstadisticaTrabajador.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticaTrabajador.vue?vue&type=style&index=0&id=be519d08&lang=scss&scoped=true&"
import style1 from "./EstadisticaTrabajador.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be519d08",
  null
  
)

export default component.exports